require('../styles/index.scss');

const $                         = require('jquery');
const _                         = require('underscore');
const FileSaver                 = require('file-saver');
const { detect }                = require('detect-browser');
const { default: FindPanel }    = require('@readcube/find-panel');
const { default: DocdelAccess } = require('@readcube/docdel-access');
const Extension                 = require('@readcube/extension-detect');
const Importer                  = require('@readcube/extension-importer');
const user                      = require('./user');
const evtbus                    = require('./evtbus');
const evtout                    = require('./evtout');
const platform                  = require('./platform');
const exporter                  = require('./util/exporter');
const exportHelper              = require('./util/export_helper');
const pickItem                  = require('./util/pick_item');
const downloadBuffer            = require('./util/download_buffer');
const sidepanel                 = require('./ctrl/sidepanel');
const Preview                   = require('./comp/preview');
const MenuBar                   = require('./comp/menu_bar');
const Supplements               = require('./comp/supplements');
const Figures                   = require('./comp/figures');
const VideoPlayer               = require('./comp/video_player');
const FigureViewer              = require('./comp/figure_viewer');
const CitationExport            = require('./comp/citation_export');
const RelatedArticles           = require('./comp/related_articles');
const References                = require('./comp/references');
const Metrics                   = require('./comp/metrics');
const TrackJS                   = require('./includes/trackjs');

require('./comp/user_details');

const browser = detect();

class DocdelPreview {
  constructor({
      container,
      env,
      doi,
      syncApi,
      uploader,
      importTo,
      test = {}
    }) {

    container ??= document.body;

    if (platform.app) {
      $(() => {
        $(container).on('click', 'a[target]', function(e) {
          e.preventDefault();
          evtout.trigger('open-url', [$(this).attr('href')]);
        });
      });
    }

    this._env = env;
    this._doi = doi;
    this._syncApi = syncApi;
    this._uploader = uploader;
    this._article = {};

    this._container = $(`<div class="docdel-preview"></div>`);
    this._container.appendTo(container);

    const accessContainer = $(`
      <div class="access-container">
        <div class="header">ACCESS OPTIONS</div>
        <div class="content"></div>
      </div>
    `).appendTo(container);

    sidepanel.init({ container: this._container });

    user.init({ syncApi }).then(() => {
      TrackJS.setUser(user.data);

      this._access = new DocdelAccess({ env, doi, syncApi, importTo, test,
        container: accessContainer.find('.content')[0],
        user: user.data
      });
      this._container.parent().addClass('access-open');

      fetchMetadata().then(metadata => {
        this._article = metadata;
        if (!_.isEmpty(metadata)) {
          this._preview = new Preview({ user: user.data, container: this._container, metadata });
          this._supplements = new Supplements({ container: this._container, metadata });
          this._figures = new Figures({ container: this._container, metadata });
          this._related = new RelatedArticles({ container: this._container, metadata, syncApi });
          this._references = new References({ container: this._container, metadata, syncApi });
          this._metrics = new Metrics({ container: this._container, metadata, syncApi });
        } else {
          this._container.append(`
            <missing-meta>
              <h2>Unfortunately we don't have metadata on this article yet...</br>You can still try accessing the article PDF using the access options on the right.</h2>
            </missing-meta>
          `);
        }

        Promise.all([
          checkStatus(),
          checkDocdel(),
          ensureImporter()
        ]).then(([status, docdelInfo, importer]) => {
          this._importer = importer;
          this._item = pickItem(status);

          if (!_.isEmpty(metadata)) {
            this._menu = new MenuBar({
              container: this._container, item: this._item, metadata, syncApi
            });
            this._export = new CitationExport({
              container: this._container, metadata, item: this._item, user: user.data, syncApi
            });

            if (syncApi.push) {
              let collectionId = this._item?.collection_id;
              collectionId ??= docdelInfo.collection_id;
              collectionId ??= user.data.id;
              syncApi.push.subscribeCollection({ collectionId }, message => {
                const change = message.changes.find(c => {
                  return c.action == 'created' && c.doi == doi;
                });
                if (change) {
                  syncApi.items.find({ doi }).then(response => {
                    this._setItem(response.item);
                  }).catch(() => {});
                }
              });
            }
          }

          this._bindEvents();
          this._access.render({ status, docdelInfo, importer })
            .catch(err => console.error(err));
        });
      });
    });

    function checkStatus() {
      if (window.status_response) {
        if (window.status_response.items) {
          return Promise.resolve(window.status_response);
        }
        // does not contain sync items data
        return syncApi.status.checkExtIds({ extIds: [{ doi }] })
          .then(([items]) => Object.assign(window.status_response, { items }));
      }
      return syncApi.institution.status({ dois: [doi] })
        .then(response => {
          return window.status_response = response[doi];
        });
    }

    function checkDocdel() {
      if (window.docdel_response) {
        return Promise.resolve(window.docdel_response);
      }
      return syncApi.docdel.info({ doi }).then(response => {
        return window.docdel_response = response;
      })
    }

    function fetchMetadata() {
      return new Promise(resolve => {
        syncApi.reader.abstract({ doi })
          .then(resolve)
          .catch(reason => {
            if (reason.error == 'content_missing') {
              evtout.trigger('open-url', [`https://doi.org/${encodeURIComponent(doi)}`]);
            } else {
              resolve({});
            }
          });
      });
    }

    function ensureImporter() {
      const extension = new Extension({ env, minVersion: '4.4.0' });
      return extension.isInstalled().then(installed => {
        if (installed.result || test.extension == 'installed') {
          return new Importer({ env, extVersion: installed.version });
        }
        return null;
      });
    }
  }

  get evtout() {
    return evtout;
  }

  _setItem(item) {
    this._item = item;
    this._menu && this._menu.setItem(item);
  }

  _createItem({ extIds, resolveFiles = false }) {
    if (!_.isEmpty(this._item)) return Promise.resolve({ item: this._item });
    return this._uploader.create({
      collectionId: user.data.id, extIds, resolveFiles, skipResolveFiles: !resolveFiles
    });
  }

  _addToLibrary({ buffer, url, logClientAccessObject } = {}) {
    url ??= this._access.pdfUrl;
    buffer ??= this._access.pdfBuffer;

    const extIds = { doi: this._doi };
    const resolveFiles = !url && !buffer;

    this._createItem({ extIds, resolveFiles }).then(async ({ item }) => {
      if (!buffer && url) {
        buffer = await downloadBuffer({ url });
      }
      if (buffer) {
        let { collection_id: collectionId, id: itemId } = item;
        let fileName = this._article?.meta?.title || exportHelper.getKey(item);
        fileName = (fileName || 'article').replace( /[<>:"\/\\|?*]+/g, '') + '.pdf';
        this._uploader.add({ collectionId, itemId, fileName, buffer, primary: true })
          .then(({ item }) => {
            this._setItem(item);
            this._logClientAccess(true, logClientAccessObject, item);
          }).catch(err => {
            console.error(err);
            this._setItem(item);
            this._logClientAccess(false, logClientAccessObject, item);
          });
      } else {
        this._setItem(item);
      }
    }).catch(err => {
      console.error(err);
      this._setItem(this._item);
    });
  }

  _logClientAccess(fileUploaded, logClientAccessObject, item) {
    if (!this._importer || !logClientAccessObject) return;
    const { collection_id, id: item_id } = item;
    logClientAccessObject = { ...logClientAccessObject, collection_id, item_id };
    this._importer.logClientAccess({ fileUploaded, logClientAccessObject });
  }

  _bindEvents() {
    evtbus.on('search-fulltext', () => {
      this._openSearch();
    });
    evtbus.on('add-to-library', () => {
      this._addToLibrary()
    });
    this._access.evtout.on('pdf-buffer', (e, buffer, logClientAccessObject) => {
      if (!this._item || !this._item.has_file) {
        this._addToLibrary({ buffer, logClientAccessObject });
      }
      evtout.trigger('received-pdf', [buffer]);
    });
    this._access.evtout.on('pdf-url', (e, url) => {
      if (!this._item || !this._item.has_file) {
        this._addToLibrary({ url });
      }
      evtout.trigger('received-pdf-url', [url]);
    });
    this._access.evtout.on('open-pdf', (e, buffer) => {
      evtout.trigger('open-pdf', [buffer]);
    });
    this._access.evtout.on('open-pdf-url', (e, url) => {
      evtout.trigger('open-pdf-url', [url]);
    });
    this._access.evtout.on('open-url', (e, url) => {
      evtout.trigger('open-url', [url]);
    });
    this._access.evtout.on('open-in-library', (e, item) => {
      evtout.trigger('open-in-library', [item]);
    });
    this._access.evtout.on('read-in-library', (e, item) => {
      evtout.trigger('read-in-library', [item]);
    });
    this._access.evtout.on('upload-complete', (e, item) => {
      this._setItem(item);
    });
    this._access.evtout.on('in-library', (e, items) => {
      this._syncApi.items.find({ doi: this._doi })
        .then(({ item }) => this._setItem(item))
        .catch(() => {});
    });
    evtbus.on('play-video', (e, index, videos) => {
      VideoPlayer.open(index, videos, $('body'));
    });

    evtbus.on('open-figure', (e, index, figures) => {
      FigureViewer.open(index, figures, $('body'));
    });
    evtbus.on('export-citation', async (e, format, mapping, item) => {
      if (platform.app) {
        evtout.trigger('export-citation', [format, mapping, item]);
        return;
      }

      const opts = { type: 'text/plain;charset=UTF-8' };
      const text = await exporter(format, item, mapping);
      const blob = new Blob([$(`<p>${text}</p>`).text()], opts);
      const name = encodeURIComponent(exportHelper.getKey(item)) + '.' + format;

      if (browser.name != 'crios') {
        FileSaver.saveAs(blob, name);
      } else {
        window.open(URL.createObjectURL(blob), '_blank');
      }
    });
  }

  _openSearch() {    
    this._findElem ??= $('<div></div>');

    sidepanel.open({
      id: 'search', content: this._findElem,
      title: 'Search within PDF'
    });

    this._findPanel ??= new FindPanel({
      container: this._findElem,
      api: {
        fulltext: _.memoize(() => {
          return this._syncApi.docdel.fulltext({ doi: this._doi });
        })
      }
    });
  }
}

module.exports = DocdelPreview;
